<script lang="ts">
    import {Component, toNative, Prop, Vue} from 'vue-facing-decorator'
    import EmailsField from '~/components/snippets/forms/EmailsField.vue'

    @Component({mixins: [EmailsField]})
    export class ServiceVariantsField extends Vue {
        @Prop() variantsAvailable

        mounted() {
            if (this.variantsAvailable?.length) {
                this.items = [...this.items, ...this.variantsAvailable]
            }
        }

        updateSearchInput(val) {
            this.searchInput = val
            const variantsArray = this.multiple ? this.emails : [this.emails]
            if (!variantsArray.includes(val)) {
                this.items = [val, ...variantsArray]
            } else {
                this.items = variantsArray
            }

            if (this.variantsAvailable?.length) {
                this.items = [...this.items, ...this.variantsAvailable]
            }
        }

        keydown(event) {
            const variantsArray = this.multiple ? this.emails : [this.emails]

            if (['Enter', 'NumpadEnter'].includes(event.code) && !variantsArray.includes(this.searchInput)) {
                if (this.multiple) {
                    this.emails.push(this.searchInput)
                } else {
                    this.emails = [this.searchInput]
                }

                this.searchInput = ''
            }
        }
    }

    export default {...toNative(ServiceVariantsField), ssrRender: EmailsField.ssrRender}
</script>
